export enum AppLang {
	EN = 'en',
	ES = 'es',
	FR = 'fr',
	DE = 'de',
	PT = 'pt',
}

export const appLangs: LangModel<AppLang>[] = [
	{ language: AppLang.EN, name: 'English', country_code: 'US' },
	{ language: AppLang.ES, name: 'Spanish', country_code: 'ES' },
	{ language: AppLang.FR, name: 'French', country_code: 'FR' },
	{ language: AppLang.DE, name: 'German', country_code: 'DE' },
	{ language: AppLang.PT, name: 'PORTUGESE', country_code: 'PT' },
]

export type Lang = 'af' | 'ak' | 'sq' | 'am' | 'ar' | 'hy' | 'as' | 'ay' | 'az' | 'bm' | 'eu' | 'be' | 'bn' | 'bho' | 'bs' | 'bg' | 'ca' | 'ceb' | 'ny' | 'zh' | 'zh' | 'co' | 'hr' | 'cs' | 'da' | 'dv' | 'doi' | 'nl' | 'en' | 'eo' | 'et' | 'ee' | 'tl' | 'fi' | 'fr' | 'fy' | 'gl' | 'lg' | 'ka' | 'de' | 'gom' | 'el' | 'gn' | 'gu' | 'ht' | 'ha' | 'haw' | 'iw' | 'hi' | 'hmn' | 'hu' | 'is' | 'ig' | 'ilo' | 'id' | 'ga' | 'it' | 'ja' | 'jw' | 'kn' | 'kk' | 'km' | 'rw' | 'ko' | 'kri' | 'ku' | 'ckb' | 'ky' | 'lo' | 'la' | 'lv' | 'ln' | 'lt' | 'lb' | 'mk' | 'mai' | 'mg' | 'ms' | 'ml' | 'mt' | 'mni' | 'mi' | 'mr' | 'lus' | 'mn' | 'my' | 'ne' | 'nso' | 'no' | 'or' | 'om' | 'ps' | 'fa' | 'pl' | 'pt' | 'pa' | 'qu' | 'ro' | 'ru' | 'sm' | 'sa' | 'gd' | 'sr' | 'st' | 'sn' | 'sd' | 'si' | 'sk' | 'sl' | 'so' | 'es' | 'su' | 'sw' | 'sv' | 'tg' | 'ta' | 'tt' | 'te' | 'th' | 'ti' | 'ts' | 'tr' | 'tk' | 'uk' | 'ur' | 'ug' | 'uz' | 'vi' | 'cy' | 'xh' | 'yi' | 'yo' | 'zu' | 'he' | 'jv' | 'zh'

export class LangModel<L = Lang> {
    language: L;
    name: string;
	country_code?: string
}

export class TranslationLanguage {
	translation: boolean;
	language: Lang;

	user_id: number;
	tenant_id?: number;

	created_dt: Date;
	updated_dt: Date;
}